/** 10 minutes - allow swr to automatically refresh data after this time */
export var defaultTTL = 1000 * 60 * 10;